import { RouteConfig } from 'vue-router';

import WelcomeInvite from '../views/InviteOneway/InviteOneway';
import NotFoundComponent from '../views/NotFound/NotFoundComponent';
import { OrgRegistration } from '../views/OrgRegistration/OrgRegistration';
import ParticipantJoin from '../views/ParticipantJoin/ParticipantJoin';
import { SharePlaybackInvite } from '../views/ParticipantJoin/SharePlaybackInvite';
import { YCOISlotPickInvite } from '../views/ParticipantJoin/YCOISlotPickInvite';
import Registration from '../views/Registration/Registration';

export const ROUTE_REGISTRATION_CAND = 'registration-candidate';
export const ROUTE_REGISTRATION_INTR = 'registration-interviewer';
export const ROUTE_REGISTRATION_ORGS = 'registration-organization';

export function makeRoutes(): RouteConfig[] {
    const routes: RouteConfig[] = [];

    // When user is opening a shared playback
    routes.push({
        path: '/share/playback/:shareCode',
        name: 'share-playback',
        component: SharePlaybackInvite
    });

    routes.push({
        path: '/invite/ycoi/:code?',
        name: 'ycoi-invite',
        component: YCOISlotPickInvite
    });

    routes.push({
        path: '/invitations/:inviteCode',
        name: 'invitation',
        component: WelcomeInvite
    });

    routes.push({
        path: '/join/:participantCode?',
        name: 'join',
        component: ParticipantJoin
    });

    routes.push({
        path: '/candidate/registration',
        name: ROUTE_REGISTRATION_CAND,
        component: Registration
    });

    routes.push({
        path: '/interviewer/registration',
        name: ROUTE_REGISTRATION_INTR,
        component: Registration
    });

    routes.push({
        path: '/organization/registration',
        name: ROUTE_REGISTRATION_ORGS,
        component: OrgRegistration
    });

    routes.push({
        path: '*',
        name: 'notfound',
        component: NotFoundComponent
    });

    return routes;
}
